<template>
	<m-main-layout>
		<el-button @click="$router.back()">返回</el-button>
		<el-table border size="mini" :data="list" style="width: 100%;margin-top:10px;">
			<el-table-column type="index" label="排序"></el-table-column>
			<el-table-column show-overflow-tooltip prop="title" label="标题">
				<template slot-scope="scope">
					<a :href="$config.webUrl + '/bids/detail/'+scope.row.id" target="_blank">{{scope.row.title}}</a>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="company" label="公司名称" width="180px">
				<template slot-scope="scope">
					<a :href="$config.webUrl + '/company/detail/'+scope.row.uid" target="_blank">{{scope.row.company}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="click_count" label="浏览量" width="80px"></el-table-column>
		</el-table>
		<div class="padding-top-bottom-20 text-center">
			<el-pagination
				background
				layout="total,prev, pager, next"
				:page-size="searchForm.pageSize"
				:current-page.sync="searchForm.page"
				:total="totalCount"
				@current-change="pageChange">
			</el-pagination>
		</div>
	</m-main-layout>
</template>

<script>
export default {
	name: "bids",
	data() {
		return {
			searchForm:{
				page:1,
				pageSize:20,
				orderBy:'click_count',
				sortBy:'desc'
			},
			totalCount:0,
			list:[]
		}
	},
	created() {
	},
	mounted() {
		this.getList();
	},
	methods: {
		getList(){
			let _this = this;

			_this.$http.httpPost({
				url: '/Bids/listPage',
				datas: this.searchForm,
				success: (res) => {
					_this.list = res.list;
					_this.totalCount = res.totalCount;
				}
			});
		},
		pageChange(page){
			this.page = page;
			this.getList();
		},
	}
}
</script>
